// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4":"d2a5174bc769bcc5","464":"9f31d4e008c05822"}[chunkId] + ".js";
};